import React from 'react';
import moment from 'moment';
import { recordingDelete } from '../../modules/EventCard/EventCardActions';
import { connect } from 'react-redux';

class PosterTitleTrash extends React.Component {
  constructor() {
    super();
    this.delete = this.delete.bind(this);
  }

  delete() {
    if (this.props.actionRecording) {
      this.props.recordingDelete(this.props.config, {
        actions: this.props.actionRecording.delete,
      });
    }
  }

  render() {
    return (
      <div className="col-md-12">
        <div className="title-recording--div">
          <p className="title-recording--p">
            {this.props.resource.ext_original_name}
          </p>
          <p className="title-recording--p-date">{`${moment(
            this.props.resource.date_begin * 1000,
          ).format('DD/MM/YY | HH:mm')} hrs`}</p>
        </div>
        <div className="trash-recording--div">
          <span className="trash-recording--p">
            {' '}
            <i className="fa fa-trash-o" onClick={e => this.delete()} />
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  config: store.config,
});

const mapDispatchToProps = dispatch => ({
  recordingDelete(config, data) {
    dispatch(recordingDelete(config, data));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PosterTitleTrash);
